module.exports = __webpack_public_path__ + "img/apple.518b4553.svg";